import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import React from "react";

export default function SuccessfulySavedQuestFormModal({ onClose }) {
  const { t } = useTranslation();
  return (
    <BaseModal
      onClose={onClose}
      description={t("modals.successfuly_saved_quest_form_modal.desc")}
      eventTypeModal={MODAL_TYPES.SUCCESSFULY_SAVED_QUEST_FORM_MODAL}
    />
  );
}
